import { UnknownKeyValuePairs } from './types'

/**
 * Feeding Recommendation Selector.
 */
export const feedingRecommendation = (attributes: UnknownKeyValuePairs): string =>
    attributes.core.attr12
